export default __webpack_public_path__ + "static/media/copper.7a0d4648.png";